import { Button, makeStyles, createStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import AddIcon from "@material-ui/icons/Add";
import { useDialogProps } from "legacy-components/dialog/Dialog";
import CreateDeploymentDialog from "../../components/CreateDeploymentDialog";
import { useSelector } from "react-redux";
import type { DeploymentCreatorProps } from "./deploymentCreatorTypes";

const DEPLOYMENT_HEADER_CONTROL_HEIGHT = 40;

const useStyles = makeStyles((theme) =>
  createStyles({
    addButton: {
      height: DEPLOYMENT_HEADER_CONTROL_HEIGHT,
      minHeight: DEPLOYMENT_HEADER_CONTROL_HEIGHT,
      padding: theme.spacing(0, 2),
      "&.Mui-disabled": {
        opacity: 1,
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.grey[600],
      },
      "&.Mui-disabled .MuiButton-startIcon": {
        color: theme.palette.grey[500],
      },
    },
  })
);

/** As on `develop`: modal dialog, Redux-driven region list, no regions API. */
export const DeploymentCreatorLegacy: React.FC<DeploymentCreatorProps> = ({
  resourceAppId,
  version,
  refreshDeploymentList,
  deployedRegions,
  basePath,
}) => {
  const { open, toggle } = useDialogProps();
  const onSuccess = () => {
    refreshDeploymentList();
  };

  const identityEnvironment = useSelector(
    (state: any) => state?.common?.identityEnvironment ?? "trimble-pre-prod"
  );

  const isFedRamp = process.env.REACT_APP_IS_FEDRAMP === "true";

  const [availableRegions, setAvailableRegions] = useState(
    identityEnvironment === "trimble-prod"
      ? [
          { key: "Global", value: "global" },
          { key: "EU-West", value: "eu-west" },
        ]
      : [{ key: "Global", value: "global" }]
  );

  useEffect(() => {
    const baseRegions =
      identityEnvironment === "trimble-prod"
        ? [
            { key: "Global", value: "global" },
            { key: "EU-West", value: "eu-west" },
          ]
        : [{ key: "Global", value: "global" }];

    const updatedRegions = baseRegions.filter((region) => {
      if (deployedRegions?.includes("global")) {
        return (
          region.value !== "global" && !deployedRegions?.includes(region.value)
        );
      }

      return !deployedRegions?.includes(region.value);
    });

    setAvailableRegions(updatedRegions);
  }, [deployedRegions, identityEnvironment]);

  /** Regions left to deploy — empty when every base region already has a deployment */
  const isDeploymentDisabled = !availableRegions?.length;

  const classes = useStyles();

  return (
    <>
      <Button
        disabled={isDeploymentDisabled}
        size="medium"
        variant="contained"
        color="primary"
        className={classes.addButton}
        startIcon={<AddIcon />}
        onClick={() => toggle()}
      >
        Add New Deployment
      </Button>
      <CreateDeploymentDialog
        open={open}
        onClose={toggle}
        onSuccess={onSuccess}
        basePath={basePath}
        resourceAppId={resourceAppId}
        version={version}
        availableRegions={availableRegions}
      />
    </>
  );
};
